export class Department {
    id : number
    designation : string
    abbreviation : string;
    establishment_id : number = JSON.parse(localStorage.getItem('user-infos')).establishment_id;;
}
